import { render, staticRenderFns } from "./purgroup.vue?vue&type=template&id=bdd8189a&scoped=true&"
import script from "./purgroup.vue?vue&type=script&lang=js&"
export * from "./purgroup.vue?vue&type=script&lang=js&"
import style0 from "./purgroup.vue?vue&type=style&index=0&id=bdd8189a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd8189a",
  null
  
)

export default component.exports